import { PayloadAction, PayloadMetaAction } from 'typesafe-actions';
import { IdRequestPartialModel } from '../../models/api-request.models';
import { ApiResponse } from '../../models/api-response.models';
import { ErrorNormalized } from '../../models/error.models';
import { IdModel } from '../../models/id.models';
import { ItemState } from '../../models/state.models';

const request = <TEntity extends IdModel, TEntityState extends ItemState<TEntity>>(
    state: TEntityState,
    action: PayloadAction<any, IdRequestPartialModel<TEntity>>
): TEntityState => ({
    ...state,
    itemStates: {
        ...state.itemStates,
        [action.payload.id]: {
            ...state.itemStates[action.payload.id],
            deleteState: { loading: true },
        },
    },
});

const success = <TEntity extends IdModel, TEntityState extends ItemState<TEntity>>(
    state: TEntityState,
    action: PayloadAction<any, ApiResponse<TEntity>>
): TEntityState => ({
    ...state,
    items: {
        ...state.items,
        [action.payload.data.id]: undefined,
    },
    itemStates: {
        ...state.itemStates,
        [action.payload.data.id]: {
            ...state.itemStates[action.payload.data.id],
            deleteState: { loading: false },
        },
    },
});

const failure = <TEntity extends IdModel, TEntityState extends ItemState<TEntity>>(
    state: TEntityState,
    action: PayloadMetaAction<any, ErrorNormalized, IdModel>
): TEntityState => ({
    ...state,
    itemStates: {
        ...state.itemStates,
        [action.meta.id]: {
            ...state.itemStates[action.meta.id],
            deleteState: { loading: false, error: action.payload },
        },
    },
});

export const deleteItemHelper = {
    request,
    success,
    failure,
};
